import { render } from "./AddOnAdditionalManifest.vue?vue&type=template&id=1bd85ae2"
import script from "./AddOnAdditionalManifest.vue?vue&type=script&lang=js"
export * from "./AddOnAdditionalManifest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__